import * as Yup from "yup";

export const validateRowSchema = Yup.object().shape({
    minValue: Yup
        .string()
        .required("Required"),
    maxValue: Yup
        .string()
        .required("Required"),
    itemRate: Yup
        .string()
        .required("Required"),
})

export const validationSchema = Yup.object({
    ruleName: Yup
        .string()
        .required("Required"),
    baseFee: Yup
        .string()
        .required("Required"),
    calculationType: Yup
        .string()
        // .min(1, "Min 1 selection")
        .required('Required'),
    // description: Yup
    //     .string()
    //     .required("Required"),
    measureType: Yup
        .string()
        .required("Required"),
    chargeMethod: Yup
        .string()
        .required("Required"),
    customerGroup: Yup.array()
        .of(Yup.string())
        // .min(1, "Min 1 selection")
        .required("Required"),

    rows: Yup.array().of(validateRowSchema),
})

export const initialRowValues = {
    minValue: "",
    maxValue: "",
    itemRate: "",
}

export const initialValues = {
    ruleName: "",
    calculationType: "",
    baseFee: "",
    description: "",
    status: true,
    measureType: "",
    chargeMethod: "",
    customerGroup: [],
    rows: [initialRowValues],
}

export const measureTypes = [
    {
        id: "weight",
        display: "Weight"
    },
    {
        id: "cbm",
        display: "CBM"
    },
    {
        id: "unit",
        display: "Unit"
    },
]

export const chargeMethods = [
    {
        id: `item_rate_multiply_input_value`,
        display: "Yes (Output: Item Rate x Input Value)"
    },
    {
        id: `item_rate_only`,
        display: "No (Output: Item Rate Only)"
    }
]